<!--

    DEPRECATED COMPONENT

-->
<template>
    <div>
        <div class="mb-6 -mt-4">
            <h1 class="mb-3">ID Selfie Upload</h1>
        </div>

        <ValidationObserver ref="proofOfIdentitySelfieObserver">
            <div class="mb-6">
                Please upload two different selfie images of yourself, making sure your face is clearly visible and in the centre of both images.
            </div>
            <div class="upload-guide mb-6">
                <div class="flex items-center mb-5">
                    <div class="mr-4 shrink-0">
                        <img width="30" height="30" :src="global.app.url + 'images/icons/upload-guide-centered.svg'" />
                    </div>
                    <div class="">Ensure your face is centred in the frame</div>
                </div>
                <div class="flex items-center mb-5">
                    <div class="mr-4 shrink-0">
                        <img width="30" height="30" :src="global.app.url + 'images/icons/upload-guide-plain.svg'" />
                    </div>
                    <div class="">Ensure the photo is taken on a light, plain background</div>
                </div>
                <div class="flex items-center mb-5">
                    <div class="mr-4 shrink-0">
                        <img width="30" height="30" :src="global.app.url + 'images/icons/upload-guide-light.svg'" />
                    </div>
                    <div class="">Ensure the image is taken in light conditions</div>
                </div>
                <div class="flex items-center">
                    <div class="mr-4 shrink-0">
                        <img width="30" height="30" :src="global.app.url + 'images/icons/upload-guide-focussed.svg'" />
                    </div>
                    <div class="">Image should be in focus and in high quality. File size must not exceed 8MB.</div>
                </div>
            </div>

            <div class="mb-6" v-if="hasSelfieError">
                <AlertComponent :message="'There was a problem with your selfie(s). Reason: ' + global.submission_errors.isSelfieError" />
            </div>

            <div class="mb-6">
                <h3 class="font-bold uppercase mb-3">Selfie 1</h3>

                <FileUploadComponent
                    id="poi-selfie-1"
                    name="poi_selfie_1"
                    label="Upload an image"
                    :apiEndpointUrl="'/user/' + this.user.id + '/poi/selfies/1'"
                    :fileData="proofOfIdentitySelfies[0]"
                />
            </div>

            <div class="mb-6">
                <h3 class="font-bold uppercase mb-3 pt-4">Selfie 2</h3>

                <FileUploadComponent
                    id="poi-selfie-2"
                    name="poi_selfie_2"
                    label="Upload an image"
                    :apiEndpointUrl="'/user/' + this.user.id + '/poi/selfies/2'"
                    :fileData="proofOfIdentitySelfies[1]"
                />
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ValidationObserver } from "vee-validate";
import InputComponent from "@components/inputs/InputComponent";
import stepperValidationService from "@services/stepperValidationService";

export default {
    name: "POISelfieFormComponent",
    props: {},
    components: {
        ValidationObserver,
    },
    props: {
        step: { default: "" },
    },
    computed: {
        ...mapGetters(["user", "global", "proofOfIdentitySelfiesState"]),
        proofOfIdentitySelfies: {
            get() {
                return this.proofOfIdentitySelfiesState;
            },
            set(value) {
                return value;
            },
        },
    },
    data() {
        return {
            isFormValidated: false,
            hasSelfieError: false
        };
    },
    methods: {
        ...mapActions(["doGetProofOfIdentitySelfies"]),
        doValidateForm() {
            stepperValidationService.checkStepperStepStatus(
                this.step,
                this.proofOfIdentitySelfies,
                this.$refs.proofOfIdentitySelfieObserver,
                false,
                true
            );
        },
    },
    mounted() {
        this.$root.$on("submittingApplication", () => this.doValidateForm());
        this.$root.$on("stepChanged", (step) => {
            if (this.step < step && !this.isFormValidated) {
                this.doValidateForm();
                this.isFormValidated = true;
            } else if (this.step == step) {
                this.isFormValidated = false;
            }
        });

        this.$root.$on("isSelfieError", () => this.hasSelfieError = true );

        this.doGetProofOfIdentitySelfies();
    },
    watch: {
        proofOfIdentitySelfies() {
            stepperValidationService.checkStepperStepStatus(
                this.step,
                this.proofOfIdentitySelfies,
                this.$refs.proofOfIdentitySelfieObserver
            );
        },
        "$route.params.step"() {
            if (this.$route.params.step === this.step) this.doGetProofOfIdentitySelfies();
        },
    },
};
</script>
